import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

const SkeletonWrapper = styled.div`
    width: 280px;
    flex-shrink: 0;
    padding: 20px;
    border-radius: 16px;
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
`;

const SkeletonContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const SkeletonHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    width: 100%;
`;

const SkeletonCircle = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #eee;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonBadge = styled.div`
    width: 100px;
    height: 32px;
    border-radius: 8px;
    background-color: #eee;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonTitle = styled.div`
    width: 70%;
    height: 24px;
    margin-bottom: 10px;
    background-color: #eee;
    border-radius: 4px;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonSubtitle = styled.div`
    width: 40%;
    height: 16px;
    margin-bottom: 10px;
    background-color: #eee;
    border-radius: 4px;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonText = styled.div`
    width: 100%;
    height: 16px;
    margin-bottom: 6px;
    background-color: #eee;
    border-radius: 4px;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonStats = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 22px;
    margin-bottom: 22px;
    width: 100%;
`;

const SkeletonBox = styled.div`
    background-color: #f9fafb;
    border-radius: 12px;
    padding: 16px;
    flex: 1;

    &:first-child {
        margin-right: 12px;
    }
`;

const SkeletonValue = styled.div`
    width: 80%;
    height: 20px;
    background-color: #eee;
    border-radius: 4px;
    margin: 0 auto;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonLabel = styled.div`
    width: 60%;
    height: 12px;
    margin: 6px auto 0;
    background-color: #eee;
    border-radius: 4px;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonProgress = styled.div`
    margin-top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

const SkeletonBar = styled.div`
    width: 100%;
    height: 8px;
    background-color: #eee;
    border-radius: 4px;
    animation: ${pulse} 1.5s infinite;
`;

const SkeletonFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    width: 100%;
`;

const SkeletonParticipants = styled.div`
    display: flex;
    align-items: center;
`;

const SkeletonButton = styled.div`
    width: 120px;
    height: 32px;
    background-color: #eee;
    border-radius: 6px;
    animation: ${pulse} 1.5s infinite;
`;

const PadItemSkeleton: React.FC = () => {
    return (
        <SkeletonWrapper>
            <SkeletonContent>
                <SkeletonHeader>
                    <SkeletonCircle />
                    <SkeletonBadge />
                </SkeletonHeader>

                <SkeletonTitle />
                <SkeletonSubtitle />
                <SkeletonText />
                <SkeletonText />
                <SkeletonText />

                <SkeletonStats>
                    <SkeletonBox>
                        <SkeletonValue />
                        <SkeletonLabel />
                    </SkeletonBox>

                    <SkeletonBox>
                        <SkeletonValue />
                        <SkeletonLabel />
                    </SkeletonBox>
                </SkeletonStats>

                <SkeletonProgress>
                    <SkeletonBar />
                </SkeletonProgress>
            </SkeletonContent>

            <SkeletonFooter>
                <SkeletonParticipants>
                    <SkeletonCircle
                        style={{
                            width: '24px',
                            height: '24px',
                            marginRight: '8px',
                        }}
                    />
                    <SkeletonText style={{ width: '120px', margin: 0 }} />
                </SkeletonParticipants>
                <SkeletonButton />
            </SkeletonFooter>
        </SkeletonWrapper>
    );
};

export default PadItemSkeleton;
